import React from 'react';
import { useTranslation } from 'react-i18next';
import './EmptyState.css'; // Импортируем стили

function EmptyState() {
  const { t } = useTranslation();

  return (
    <div className="emptystate__container">
      <div className="emptystate__panel">
        <h2 className="emptystate__title">{t('emptyState.title')}</h2>
        <div className="emptystate__description">
          <p>
            {t('emptyState.intro')}
          </p>
          <div className="emptystate__features">
            <h3 className="emptystate__subtitle">{t('emptyState.featuresTitle')}</h3>
            <ul>
              <li>{t('emptyState.feature1')}</li>
              <li>{t('emptyState.feature2')}</li>
              <li>{t('emptyState.feature3')}</li>
            </ul>
          </div>
          <div className="emptystate__guide">
            <h3 className="emptystate__subtitle">{t('emptyState.guideTitle')}</h3>
            <p>
              {t('emptyState.guideText')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmptyState;
